<template>
  <div class="main" :style="cssVars" :height="height">
    <UploadIdCard v-if="!(info.userIdCardBack && info.userIdCardFront)" @identity="handleIdentity" />
    <template v-else>
      <div class="left">
        <el-form ref="formData" :model="info" :rules="rules" label-width="115px" style="width: 500px">
          <el-form-item label="用户名" prop="userName">
            <el-input v-model="info.userName" class="form-item-width" disabled />
          </el-form-item>
          <el-form-item label="姓名" prop="realName">
            <el-input maxlength="20" v-model="info.realName" class="form-item-width" disabled />
          </el-form-item>
          <el-form-item label="性别" prop="gender.code">
            <el-radio-group v-model="info.gender.code" disabled>
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="民族" prop="nation">
            <el-input maxlength="20" v-model="info.nation" class="form-item-width" disabled placeholder="请输入xx族，如：汉族"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="identityNum">
            <el-input maxlength="20" v-model="info.identityNum" class="form-item-width" disabled></el-input>
          </el-form-item>
          <el-form-item label="籍贯" prop="nativePlace">
            <!--            <el-input maxlength="20" v-model="info.nativePlace" class="form-item-width" placeholder="请输入xx省xx市xx区(县)"></el-input>-->
            <el-input v-if="!isSelectNativePlace" style="width: 90%" placeholder="请输入内容" disabled v-model="info.nativePlace">
              <template slot="append">
                <el-button type="primary" @click="isSelectNativePlace=true">重新选择</el-button>
              </template>
            </el-input>
            <div v-else>
              <el-cascader
                class="!w-full"
                v-model="info.nativeplaceArr"
                :options="nativePlaceData"
                :props="{
                label: 'n',
                value: 'c',
                children: 'd'
              }"
                clearable
                filterable
                @change="handleNativePlaceChange"
              />
              <el-button style="margin-left: 10px;" type="primary" @click="isSelectNativePlace=false">返回</el-button>
            </div>

          </el-form-item>
          <el-form-item label="政治面貌" prop="political.code">
            <el-select v-model="info.political.code" filterable placeholder="请选择" class="form-item-width">
              <el-option v-for="item in politicalLists" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="就读学校" prop="institutionId">
            <el-select v-model="info.institutionId"       filterable placeholder="请选择院校名称" class="form-item-width" @change="institutChange">
              <el-option v-for="item in schoolList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="就读专业" prop="majorId">
            <el-select v-model="info.majorId"       filterable placeholder="请选择专业名称" class="form-item-width" @change="majorChange">
              <el-option v-for="item in majorList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="报考科目" prop="subjectId">
            <el-select v-model="info.subjectId" placeholder="请选择科目名称" class="form-item-width" :value="info.subjectId">
              <el-option v-for="item in subjectList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item> -->
          <el-form-item label="入学时间" prop="intakeDate">
            <el-date-picker v-model="info.intakeDate" type="date" placeholder="选择入学时间" class="form-item-width" @change="enterDateChange" />
          </el-form-item>
          <el-form-item label="考生类型" prop="examineeType.code">
            <el-select v-model="info.examineeType.code"       filterable placeholder="请选择" class="form-item-width">
              <el-option v-for="item in examineeTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学历层次" prop="eduSystem.code">
            <el-select v-model="info.eduSystem.code"       filterable placeholder="请选择" class="form-item-width">
              <el-option v-for="item in eduSystemList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号:" prop="phone">
            <el-input v-model="info.phone" class="form-item-width"></el-input>
          </el-form-item>
          <el-form-item label="邮箱:" prop="email">
            <el-input maxlength="30" v-model="info.email" class="form-item-width"></el-input>
          </el-form-item>

          <el-form-item label="联系地址" prop="address">
            <el-input maxlength="50" v-model="info.address" type="textarea" :autosize="{ minRows: 1, maxRows: 4 }" class="form-item-width"></el-input>
          </el-form-item>
          <el-form-item label="身份证人像面" class="area form-item-upload" prop="userIdCardFront" style="margin-bottom: 15px">
            <el-upload disabled class="avatar-uploader" :action="`${baseUrl}/file/upload/image`" :headers="headers" :show-file-list="false" :on-success="e => handleAvatarSuccess(e, 'userIdCardFront')">
              <div style="position: relative">
                <img v-if="info.userIdCardFront" :src="resolveImg(info.userIdCardFront)" class="id-card-avatar" style="cursor: auto;" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <!-- <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); display: flex">
                  <i title="重新识别" class="el-icon-delete" style="color: white; font-size: 20px; margin: auto" @click="info.userIdCardFront = ''"></i>
                </div> -->
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="身份证国徽面" class="area form-item-upload" prop="userIdCardBack">
            <el-upload disabled class="avatar-uploader" :headers="headers" :action="`${baseUrl}/file/upload/image`" :show-file-list="false" :on-success="e => handleAvatarSuccess(e, 'userIdCardBack')">
              <div style="position: relative">
                <img v-if="info.userIdCardBack" :src="resolveImg(info.userIdCardBack)" class="id-card-avatar" style="cursor: auto;" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <!-- <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); display: flex">
                  <i title="重新识别" class="el-icon-delete" style="color: white; font-size: 20px; margin: auto" @click="info.userIdCardBack = ''"></i>
                </div> -->
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="证件照" class="area form-item-upload" prop="avatar" style="margin-bottom: 15px">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">近期(三个月内)正面免冠彩色半身照片，背景色为蓝色（底色为RGB(100,197,255)），<br />该照片将作为合格证书使用</div>
              <el-upload
                class="avatar-uploader"
                :headers="headers"
                action=""
                accept=".jpg,.png,.jpeg"
                ref="userAvatarRef"
                :show-file-list="false"
                :before-upload="
                  e =>
                    handleBeforeUpload(e, {
                      name: 'avatar',
                      faceVerify: true
                    })
                "
              >
                <img v-if="info.avatar" :src="resolveImg(info.avatar)" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-tooltip>
          </el-form-item>

        </el-form>
        <!-- <div>
          <el-button type="primary" @click="updateInfo" class="conformBtn">确认修改</el-button>
        </div> -->
        <el-popconfirm title="确定要修改数据吗？" @confirm="updateInfo">
          <el-button slot="reference" type="primary" style="margin-bottom: 50px"> 确认修改 </el-button>
        </el-popconfirm>
      </div>
      <div class="right">
        <div class="inputBox" style="display: flex">
          <el-input type="text" v-model="authCode" placeholder="请输入验证码" style="width: 200px; margin-bottom: 30px; margin-right: 10px" />
          <div v-if="isCheck" class="check" @click="getAuthCode">
            <el-button type="primary">点击获取验证码</el-button>
          </div>
          <div v-else class="check-false">
            <el-button style="cursor: no-drop">重新获取({{ time }})</el-button>
          </div>
        </div>

        <el-button type="primary" @click="updatePassword">重置密码</el-button>
      </div>
    </template>

    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" title="提示" :visible.sync="centerDialogVisible" width="30%" center>
      <span>密码重置成功，新密码为666666。请退出重新登录</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="logOut">点击退出登录，{{ timeText }}</el-button>
      </span>
    </el-dialog>

    <el-dialog class="dialog-info" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" title="提示" :visible.sync="centerDialogVisibleNew" width="30%" center>
      <span>个人信息已修改成功,请退出重新登录</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="logOut">点击退出登录，{{ timeText }}</el-button>
      </span>
    </el-dialog>

    <ImageCropperDialog v-if="imageCropperVisible" :options="imageCropperOptions" @cropperFile="handleCropperFile" @close="imageCropperVisible = false" />
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
import { mapState } from 'vuex'
import {
  getSchoolList,
  getInfo,
  updateUserInfo,
  getMajorListNew,
  getSubjectList,
  identifyIdCardICheckIsSame
} from '@/modules/personalCenter/api/personalCenter.js'
import { resolveImg } from '@/utils/imgFill'
import { MessageBox } from 'element-ui'
import { useFileSystem, useFileTypeConvert, usePictureMainColor } from '@/hooks'
import UploadIdCard from './components/UploadIdCard.vue'
import ImageCropperDialog from '@/components/ImageCropperDialog.vue'
import cityDatas from '@province-city-china/level/level.min.json'
import { cloneDeep } from 'lodash-es'
import cityData from "@/mixins/cityData";
const { getPictureMainColor } = usePictureMainColor()
const { imageUpload } = useFileSystem()
const { base64ToFile } = useFileTypeConvert()
export default {
  components: { ImageCropperDialog, UploadIdCard },
  mixins: [cityData],
  data() {
    const validatePhone = (rule, value, callback) => {
      const regExp = /^1[0-9]\d{9}$/
      if (!regExp.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    const validateIdentityNum = (rule, value, callback) => {
      const IDCardReg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/
      if (value) {
        if (IDCardReg.test(value)) {
          callback()
        } else {
          callback(new Error('身份证号格式不正确'))
        }
      } else {
        callback(new Error('请输入身份证号'))
      }
    }
    return {
      timeText: '',
      timerId: null,
      centerDialogVisibleNew: false,
      centerDialogVisible: false,
      userInfo: {},
      height: window.innerHeight - 300,
      headers: {
        Authorization: getToken()
      },
      schoolList: [], //学校
      majorList: [], //专业
      subjectList: [], // 科目

      isSelectNativePlace:false,

      examineeTypeList: [
        {
          label: '自考',
          value: 1
        },
        {
          label: '成考',
          value: 2
        },
        {
          label: '全日制',
          value: 3
        }
      ],
      eduSystemList: [
        {
          label: '专科',
          value: 1
        },
        {
          label: '专升本',
          value: 2
        },
        {
          label: '高升本',
          value: 3
        }
      ],
      info: {
        id: '',
        userName: '',
        realName: '',
        gender: {
          code: '',
          enumCode: '',
          msg: ''
        },
        nation: '',
        nativePlace: '',
        nativeplaceArr: [],
        identityNum: '',
        political: {
          code: '',
          enumCode: '',
          msg: ''
        },
        institutionId: '',
        majorId: '',
        subjectId: '',
        intakeDate: '',
        examineeType: {
          code: '',
          enumCode: '',
          msg: ''
        },
        eduSystem: {
          code: '',
          enumCode: '',
          msg: ''
        },
        phone: '',
        email: '',
        address: '',
        avatar: '',
        userIdCardBack: '',
        userIdCardFront: ''
      },
      readonly: true,
      password: '',
      authCode: '',
      isCheck: true, //显示获取验证码
      time: 60,
      imageUrl: '',
      idCardFront: '',
      idCardBack: '',
      imageCropperVisible: false,
      imageCropperOptions: {},
      rules: {
        userIdCardFront: [{ required: true, trigger: 'blur', message: '请上传身份证人像照' }],
        userIdCardBack: [{ required: true, trigger: 'blur', message: '请上传身份证国徽照' }],
        avatar: [{ required: true, trigger: 'blur', message: '请上传证件照' }],
        userName: [{ required: true, trigger: 'blur', message: '请输入用户名' }],
        realName: [{ required: true, trigger: 'blur', message: '请输入姓名' }],
        'gender.code': [{ required: true, message: '请选择性别', trigger: 'blur' }],
        nation: [{ required: true, message: '请输入民族', trigger: 'blur' }],
        nativePlace: [{ required: true, message: '请输入籍贯', trigger: 'blur' }],
        'political.code': [{ required: true, message: '请选择政治面貌', trigger: 'blur' }],
        institutionId: [{ required: true, message: '请选择报考学校', trigger: 'blur' }],
        majorId: [{ required: true, message: '请选择报考专业', trigger: 'blur' }],
        subjectId: [{ required: true, message: '请选择报考科目', trigger: 'blur' }],
        intakeDate: [{ required: true, message: '请选择入学时间', trigger: 'blur' }],
        'examineeType.code': [{ required: true, message: '请选择考生类型', trigger: 'blur' }],
        'eduSystem.code': [{ required: true, message: '请选择学历层次', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            validator: validatePhone,
            trigger: 'change'
          }
        ],
        identityNum: [
          { required: true, message: '请输入身份证号码', trigger: 'blur' },
          {
            validator: validateIdentityNum,
            trigger: 'change'
          }
        ],
        address: [{ required: true, message: '请输入联系地址', trigger: 'blur' }]
      },
      politicalLists: [
        {
          label: '中共党员',
          value: 1
        },
        {
          label: '中共预备党员',
          value: 2
        },
        {
          label: '共青团员',
          value: 3
        },
        {
          label: '民革党员',
          value: 4
        },
        {
          label: '民盟盟员',
          value: 5
        },
        {
          label: '民建会员',
          value: 6
        },
        {
          label: '民进会员',
          value: 7
        },
        {
          label: '农工党党员',
          value: 8
        },
        {
          label: '致公党党员',
          value: 9
        },
        {
          label: '九三学社社员',
          value: 10
        },
        {
          label: '台盟盟员',
          value: 11
        },
        {
          label: '无党派人士',
          value: 12
        },
        {
          label: '群众',
          value: 13
        }
      ]
    }
  },
  // computed: {
  //   ...mapState({
  //     userInfo: (state) => state.personalCenter.userInfo,
  //   }),
  // },
  computed: {
    cssVars() {
      return {
        '--height': window.innerHeight - 600 + 'px'
      }
    },
    nativePlaceData() {
      const nativePlace = cloneDeep(cityDatas)
      nativePlace.forEach(item => {
        item.d.forEach(itemChild => {
          itemChild.d = void 0
        })
      })
      return nativePlace
    }
  },
  created() {
    this.getSchoolList()
    // this.institutChange();
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    resolveImg,
    logOut() {
      clearInterval(this.timerId)
      this.centerDialogVisible = false
      this.$store.dispatch('logout').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    handleAvatarSuccess(el, type) {
      this.info[type] = el.data.accessAddress
      this.$message.success('上传成功')
    },
    getInfo() {
      this.userInfo = JSON.parse(localStorage.getItem('fstat'))
      const userId = JSON.parse(localStorage.getItem('userInfo')).userId
      console.log(userId)
      getInfo(userId).then(res => {
        console.log(res, 9999999)
        if (res) {
          // 更新用户信息是否完善
          console.log('personalCenter')
          localStorage.setItem('fstat', JSON.stringify(res) || '{}')
          Object.keys(res).forEach(key => {
            if (this.info.hasOwnProperty(key)) {
              if (typeof this.info[key] === 'string') {
                this.info[key] = res[key] || ''
              } else {
                this.info[key] = res[key] || {}
              }
            }
          })

          if (this.info.nativePlace && this.info.nativePlace.indexOf(',')) {
            this.info.nativeplaceArr = this.info.nativePlace.split(',')
          }

          //更新专业下拉框
          this.institutChange(this.info.institutionId, false)
          this.majorChange(this.info.majorId)
        }
      })
    },
    updateInfo() {
      // if (!this.info.avatar) {
      //   this.$message.warning('请上传证件照')
      //   return
      // }
      this.$refs['formData'].validate(valid => {
        if (valid) {
          const userId = JSON.parse(localStorage.getItem('userInfo')).userId
          const params = {
            ...this.info,
            // id: userId,
            // userId: userId,
            political: this.info.political.code,
            eduSystem: this.info.eduSystem.code,
            examineeType: this.info.examineeType.code,
            gender: this.info.gender.code,
            // nativePlace: this.info.nativeplaceArr.join(',')
          }
          localStorage.setItem('institutionId', this.info.institutionId)
          updateUserInfo(params).then(res => {
            if (res) {
              console.log(res.token, 88888888888)

              this.$store
                .dispatch('refreshToken', res.token)
                .then(res => {
                  this.$message.success('修改成功！')
                  // this.$router.push('/')
                  // this.$message.success('请先进入个人中心完善个人信息！')
                })
                .catch(err => {
                  console.log(err)
                  this.err = err
                  // this.$message.error(err.data || err.msg || '登录失败')
                })

              this.getInfo()
              this.isSelectNativePlace=false
            }
          })
        } else {
          this.$message.warning('请填写完整信息')
          return false
        }
      })
    },
    countdown(seconds = 5) {
      const self = this
      this.timerId = setInterval(function () {
        console.log(seconds)
        seconds--
        self.timeText = seconds + ' 秒后自动退出登录'
        if (seconds <= 0) {
          clearInterval(self.timerId)
          self.logOut()
        }
      }, 1000)
    },
    //获取学校列表
    getSchoolList() {
      getSchoolList({ pageNum: 1, pageSize: 100 }).then(res => {
        if (res && res.list.length) {
          this.schoolList = res.list.map(item => {
            return {
              value: item.id,
              label: item.institutionName
            }
          })
        }
      })
    },
    /** 入学时间切换 */
    enterDateChange(e) {
      this.info.intakeDate = e.getTime()
    },
    /* 获取验证码 */
    getAuthCode() {
      console.log(this.userInfo)
      /* 获取验证码 */
      this.isCheck = false
      let timer = setInterval(() => {
        if (this.time > 0) {
          this.time--
        }
        if (this.time === 0) {
          this.isCheck = true
          this.time = 60
          clearInterval(timer)
        }
      }, 1000)
      const params = {
        phone: this.userInfo.phone
      }

      this.$store.dispatch('getAuthCode', params)
    },
    updatePassword() {
      if (this.authCode) {
        this.$store
          .dispatch('updatePassword', {
            id: this.info.id,
            email: this.info.email,
            password: this.password,
            inputCode: this.authCode,
            phone: this.info.phone
          })
          .then(res => {
            console.log(res)
            this.time = 0
            this.authCode = ''
            this.$message.success('密码重置成功！')
            this.centerDialogVisible = true
            this.timeText = '5 秒后自动退出登录'
            this.countdown()
          })
          .catch(err => {
            console.log(err)
            // this.$message.error(err.msg);
          })
      } else {
        this.$message.warning('请输入验证码')
      }
    },
    // 院校修改，重新查询专业
    institutChange(institutionId = '', change = true) {
      if (change) {
        this.$set(this.info, 'majorId', null)
      }
      const params = {
        pageNum: 1,
        pageSize: 100,
        condition: {
          majorName: '',
          institutionId
        }
      }
      getMajorListNew(institutionId).then(res => {
        console.log(res)
        if (res && res.length) {
          this.majorList = res.map(item => {
            return {
              value: item.id,
              label: item.majorName
            }
          })
        }
      })
    },
    // 查科目
    majorChange(majorId) {
      const params = {
        pageNum: 1,
        pageSize: 100,
        condition: {
          subjectName: '',
          majorAs: '',
          institutionId: this.institutionId,
          majorIds: majorId ? [majorId] : []
        }
      }
      getSubjectList(params).then(res => {
        // console.log('red==', res);

        if (res && res.list.length) {
          this.subjectList = res.list.map(item => {
            return {
              value: item.id,
              label: item.subjectName
            }
          })
        }
      })
    },

    async handleBeforeUpload(rawFile, options) {
      const exts = ['jpg', 'jpeg', 'png']
      let curExt = rawFile.name.slice(rawFile.name.lastIndexOf('.') + 1)
      if (!exts.includes(curExt)) {
        this.$message.error('请上传' + exts.join('、') + '的文件')
        return false
      }

      if (options.faceVerify) {
        this.imageCropperVisible = true
        const reader = new FileReader()
        reader.readAsDataURL(rawFile)
        reader.onload = () => {
          this.imageCropperOptions = {
            img: reader.result, //裁剪图片的地址
            autoCrop: true, // 是否默认生成截图框
            autoCropWidth: 480, // 默认生成截图框宽度
            autoCropHeight: 640, // 默认生成截图框高度
            fixedBox: true, // 固定截图框大小 不允许改变
            ...options
          }
        }
        return Promise.reject()


/*        const faceVerifyRes = await this.handleFaceVerify(rawFile)
        if (!faceVerifyRes) {
          return Promise.reject()
        } else {
          this.imageCropperVisible = true
          const reader = new FileReader()
          reader.readAsDataURL(rawFile)
          reader.onload = () => {
            this.imageCropperOptions = {
              img: reader.result, //裁剪图片的地址
              autoCrop: true, // 是否默认生成截图框
              autoCropWidth: 480, // 默认生成截图框宽度
              autoCropHeight: 640, // 默认生成截图框高度
              fixedBox: true, // 固定截图框大小 不允许改变
              ...options
            }
          }
          return Promise.reject()
        }*/
      }
      return Promise.resolve()
    },
    async handleFaceVerify(rawFile) {
      const baseRgb = {
        R: 100,
        G: 197,
        B: 255
      }
      // 计算RGB值之间的差异（欧几里得距离）
      //@ts-ignore
      function calculateDifference(rgb1, rgb2) {
        const diffR = rgb1.R - rgb2.R
        const diffG = rgb1.G - rgb2.G
        const diffB = rgb1.B - rgb2.B
        return Math.sqrt(diffR ** 2 + diffG ** 2 + diffB ** 2)
      }

      //@ts-ignore
      const [R, G, B] = await getPictureMainColor(rawFile)
      const resRGB = { R, G, B }

      const res = calculateDifference(baseRgb, resRGB)
      if (res > 2) {
        this.$message.error('图片底色不符合规范（RGB<100,197,255>），请重新上传')
        return false
      }
      return true
    },

    handleIdentity(info) {
      const { 姓名: realName, 公民身份号码: idcard, 性别: sex, 民族: nation } = info.identityInfo
      const { accessAddress: userIdCardFront } = info.userIdCardFront
      const { accessAddress: userIdCardBack } = info.userIdCardBack
      Object.assign(this.info, {
        realName: realName.words,
        identityNum: idcard.words,
        // 'gender.code': sex.words === '男' ? 1 : 2,
        // nativePlace: address.words,
        nation: nation.words,
        userIdCardFront,
        userIdCardBack
      })
      this.info.gender.code = sex.words === '男' ? 1 : 2
      this.$forceUpdate()
    },
    async handleCropperFile(file, options) {
      if(options.name === 'avatar'){
        const loading = this.$loading({
          lock: true,
          text: '正在检测中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        const res = await identifyIdCardICheckIsSame(file.substr(file.indexOf(',') + 1)).finally(()=>{
          loading.close()
        })
        if(!res){
          this.$message.error('证件照与身份证比对不一致，请重新上传')
          return
        }
      }
      const res = await imageUpload(base64ToFile(file))
      Object.assign(this.info, {
        [options.name]: res.accessAddress
      })


      this.imageCropperVisible = false
    },
    handleNativePlaceChange(e){
      this.isSelectNativePlace=false
      Object.assign(this.info,{
        nativePlace:this.nativePlaceFormat(e[1])
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 320px) and (max-width: 768px) {
  @import '../styles/personalCenter.mobile';
}

@media screen and (min-width: 769px) {
  @import '../styles/personalCenter.pc';
}
</style>
